import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { AppService } from './app.service';
import { ShiftsService } from '../shifts/shifts.service';
import { MatSnackBar, MatDialog } from '@angular/material';
import { AuthComponent } from '../auth/auth.component';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {

	constructor(
		public auth: AuthService,
		public app: AppService,
		private _shifts: ShiftsService,
		private _snack: MatSnackBar,
		private _dialog: MatDialog,
	) {
		app.bootstrap();
	}


	ngOnInit() {
		
		this.auth.isValid
			.subscribe(valid => {
				if (!valid) {
					this._dialog.open(AuthComponent, {disableClose: true})
				}
			})

		const shifts = this._shifts,
			today = new Date();
		
		shifts.checkDate(today)
			.subscribe(needs => {
				shifts.byDay(today)
					.subscribe(resp => {
						const save = shifts.saveShifts(resp.shifts, resp.statusRows, today, resp.scheduled);
						if (save) {
							save.subscribe(res => {
								if (
									(!res.insert || (res.insert && res.insert.keys && res.insert.keys.length)) ||
									(!res.update || (res.update && res.update.keys && res.update.keys.length))
								) {
									this._snack.open('Your schedule for today has been automatically saved.', 'OK', {duration: 3000, verticalPosition: 'top'});
								} else {
									this._snack.open('There was a problem saving the schedule for today, please validate it', 'OK', {duration: 0, verticalPosition: 'top'});
								}
							})
						} else {
							console.log('shifts checked: no changes');
						}
					})
			});
	}
	
}
